// New York's page: the GTFS page (@tol/gtfs/page) with the MTA's, PATH's
// and NJ Transit's lines.

import { createGtfsPage } from '@tol/gtfs/page';
import { NYC_PAGE } from './page.ts';

await createGtfsPage(NYC_PAGE);
